/**
 * @file  IR Contacts
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */


import React, {useContext} from 'react';
import {Divider} from 'antd';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

function IR() {
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    return (
        <div className="ir-content">
            {
                isMobile && (
                    <>
                        <div className="ir-content-title">
                            IR Contacts
                        </div>
                        <Divider />
                    </>
                )
            }

            <div className="company-boss">
                <div className="ir-company">
                    Gaotu Techedu Inc.
                </div>
                <div className="ir-name">
                    Investor Relations
                </div>
                <div className="ir-mail">
                    <a
                        href="mailto:ir@gaotu.cn"
                    >
                        ir@gaotu.cn
                    </a>
                </div>
            </div>

            {
                isMobile && (
                    <Divider />
                )
            }

            <div className="company-chris">
                <div className="chris-company">
                    Piacente Financial Communications
                </div>
                <div className="chris-name">
                    Brandi Piacente
                </div>
                <div className="chris-info">
                    {/* <div className="country">
                        In China
                    </div> */}
                    <div className="phone">
                        +1 212 481-2050
                    </div>
                    <div className="mail">
                        <a
                            href="mailto:Gaotu@tpg-ir.com"
                        >
                            Gaotu@tpg-ir.com
                        </a>
                    </div>
                </div>
            </div>

            {
                isMobile && (
                    <Divider />
                )
            }

            <div className="company-chris">
                {/* <div className="chris-company">
                    Christensen
                </div> */}
                <div className="chris-name">
                    Jenny Cai
                </div>
                <div className="chris-info">
                    {/* <div className="country">
                        In the US
                    </div> */}
                    <div className="phone">
                        +86 10 6508-0677
                    </div>
                    <div className="mail">
                        <a
                            href="mailto:Gaotu@tpg-ir.com"
                        >
                            Gaotu@tpg-ir.com
                        </a>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default IR;
